import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL,
  prepareHeaders: (headers) => {
    const token = localStorage.getItem("authtoken");
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },

});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  if (
    result.error &&
    (result.error.status === 401 || result.error.status === 403)
  ) {
        localStorage.removeItem("authtoken")
  }
  return result;
};

export const accountApi = createApi({
    reducerPath: 'accountApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getGym: builder.query({
      query: () => ({
        url: `/accounts/logo-url/`,
            })
    }),
    postLogin: builder.mutation({
      query: (data) => ({
        url: `/accounts/login/`,
                method: 'POST',
                body: data
            })
    }),
    postGym: builder.mutation({
      query: (data) => ({
        url: `/accounts/domain-create/`,
                method: 'POST',
                body: data
            })
    }),
    postGymstaff: builder.mutation({
      query: (data) => ({
        url: `/accounts/create-staff/`,
                method: 'POST',
                body: data
            })
    }),
    getGymlist: builder.query({
      query: (param) => ({
        url: `/accounts/domain-list/`,
        method: "get",
                params: param
            })
    }),
    getGymlistall: builder.query({
      query: (data) => ({
        url: `/accounts/domain-listall/`,
        method: "get",
         body: data
            })
    }),
    getGymstaff: builder.query({
      query: () => ({
        url: `/accounts/logo-url/`,
            })
    }),
    deleteGym: builder.mutation({
      query: (id) => {
        console.log("Deleting good aa ID:", id);
        return {
          url: `/accounts/domain-delete/${id}/`,
          method: "DELETE",
        };
      },
    }),

    updateGymlist: builder.mutation({
      query: ({ id, data }) => {
        console.log("Updating Gym:", data);
        return {
          url: `/accounts/domain-update/${id}/`,
          method: "PUT",
          body: data,
          formData: true,
        };
      },
    }),
    gymInfoWithDomainId: builder.query({
      query: ({ domain_id }) => {
        return {
          url: `/accounts/list-gym-info-superuser-view/${domain_id}/`,
        };
      },
    }),
  }),
});


export const {
  useGetGymlistallQuery,
  usePostLoginMutation,
  usePostGymMutation,
  usePostGymstaffMutation,
  useGetGymQuery,
  useGetGymlistQuery,
  useUpdateGymlistMutation,
  useDeleteGymMutation,
  useGymInfoWithDomainIdQuery,

} = accountApi;
